"use client";

import dynamic from "next/dynamic";

const FloatingSupportButton = dynamic(
    () => import("@/components/global/floating-support-button").then(mod => mod.FloatingSupportButton),
    { ssr: false }
);

export default function LazySupportButton() {
    return <FloatingSupportButton />;
}
